import { render, staticRenderFns } from "./MediaDetail.vue?vue&type=template&id=22e8b0dc&scoped=true&lang=pug"
import script from "./MediaDetail.vue?vue&type=script&lang=js"
export * from "./MediaDetail.vue?vue&type=script&lang=js"
import style0 from "./MediaDetail.vue?vue&type=style&index=0&id=22e8b0dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e8b0dc",
  null
  
)

export default component.exports